export default {
  machinery: 'machinery',
  home: 'home',
  orders: 'orders',
  customers: 'customers',
  customer: 'customer',
  name: 'name',
  shortName: 'short-name',
  dueDate: 'due-date',
  accounting: 'accounting',
  employees: 'employees',
  emplyee: 'employee',
  machine: 'machine',
  attachment: 'attachment',
  dashboard: 'dashboard',
  addAttachment: 'add-attachment',
  addOrderService: 'add-orderservice',
  updateOrderService: 'update-orderservice',
  editAttachment: 'edit-attachment',
  addMachine: 'add-machine',
  editMachine: 'edit-machine',
  services: 'services',
  machines: 'machines',
  attachments: 'attachments',
  addCustomer: 'add-customer',
  addSupplier: 'add-supplier',
  editSupplier: 'edit-supplier',
  editCustomer: 'edit-customer',
  mr: 'mr',
  mrs: 'mrs',
  company: 'company',
  customerEdited: 'customer-edited-message',
  somethingWentWrong: 'something-went-wrong',
  confirmMessage: 'confirm-message',
  attachmentEdited: 'attachment-edited',
  attachmentDeleted: 'attachment-deleted',
  attachmentAdded: 'attachment-added',
  machineEdited: 'machine-edited',
  machineDeleted: 'machine-deleted',
  machineAdded: 'machine-added',
  add: 'add',
  edit: 'edit',
  customerAdded: 'customer-added',
  customerRemoved: 'customer-removed',
  serviceDeleted: 'service-deleted',
  serviceAdded: 'service-added',
  serviceEdited: 'service-edited',
  addService: 'add-service',
  editService: 'edit-service',
  employeeDeleted: 'employee-deleted',
  employeeAdded: 'employee-added',
  employeeEdited: 'employee-edited',
  addEmployee: 'add-employee',
  editEmployee: 'edit-employee',
  service: 'service',
  location: 'location',
  quantity: 'quantity',
  error: 'error',
  email: 'email',
  phoneNumber: 'phone-number',
  rented: 'rented',
  supplier: 'supplier',
  suppliers: 'supplier',
  description: 'description',
  unit: 'unit',
  basePrice: 'base-price',
  netPrice: 'net-price',
  netPricePerUnit: 'net-price-per-unit',
  taxPrice: 'tax-price',
  download: 'download',
  invoices: 'invoices',
  invoice: 'invoice',
  created: 'created',
  username: 'username',
  firstName: 'first-name',
  lastName: 'last-name',
  role: 'role',
  errorOccurred: 'error-occurred',
  browserOffline: 'browser-offline'
};
